import { addNotification, getSessionSaga, reduceLoading } from 'metrix-common3';
import { call, put } from 'redux-saga/effects';
import { reduceCancellation } from '../../actions/policy/reduceCancellation';

export function* getCancellationSaga(action) {
    try {
        yield put(reduceLoading({ code: 'getCancellation', value: true }));
        // Drop the previous transaction's amounts so a failed load cannot be mistaken for a zero refund.
        yield put(reduceCancellation(null));
        const session = yield getSessionSaga();

        const response = yield call(fetch, `/api/policyCancellation/${action.payload.policyTransactionGuid}`, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                Authorization: session.authenticationToken.token,
                'Content-Type': 'application/json',
            },
        });

        const result = yield call([response, 'json']);

        if (result.operation?.status) {
            yield put(reduceCancellation(result));
        } else {
            yield put(
                addNotification({
                    code: 'getCancellation',
                    type: 'error',
                    errors: result.operation?.errors,
                    message: action.payload.errorMessage,
                }),
            );
        }

        yield put(reduceLoading({ code: 'getCancellation', value: false }));
    } catch (error) {
        console.log('Error while calling Get Cancellation API - ', error);
        yield put(reduceLoading({ code: 'getCancellation', value: false }));
        yield put(
            addNotification({
                code: 'getCancellation',
                type: 'error',
                message: action.payload.errorMessage,
            }),
        );
    }
}
